<template>
  <div class="info_form">
    <div class="title">
      人才发展
    </div>
    <el-form style="width: 680px;" :model="info_form" :rules="rules" label-position="top" ref="infoForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="晋升制度" prop="promotion_system">
        <el-checkbox-group v-model="info_form.promotion_system">
          <el-checkbox-button v-for="system in systems" :label="system" :key="system">{{system}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="人才激励" prop="talent_incentives">
        <el-checkbox-group v-model="info_form.talent_incentives">
          <el-checkbox-button v-for="system in talentIncentive" :label="system" :key="system">{{system}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="能力培养" prop="capability_development">
        <el-checkbox-group v-model="info_form.capability_development">
          <el-checkbox-button v-for="system in abilityCultivation" :label="system" :key="system">{{system}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="更多信息" prop="talent_development_info">
        <el-input type="textarea" maxlength="500" show-word-limit autosize placeholder="介绍更多相关信息，可以突出雇主品牌优势哦" v-model="info_form.talent_development_info">
        </el-input>
      </el-form-item>
    </el-form>
    <el-button class="save_button" @click="submitForm('infoForm')">保存</el-button>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      talentIncentive: [
        "定期普调",
        "定期绩效调薪",
        "晋级涨薪",
        "项目奖金",
        "绩效提成",
        "股票期权",
        "人才补贴",
      ],
      abilityCultivation: [
        "老员工带新",
        "导师一对一",
        "岗前带薪培训",
        "内部定期培训",
        "专业技能培训",
        "内部课程资源",
        "大牛带队",
        "人脉积累",
        "国内外进修",
        "校招培养",
      ],
      systems: ["考核晋升", "定期晋升", "完善的晋升机制"],
      info_form: {
        promotion_system: [],
        talent_incentives: [],
        capability_development: [],
        talent_development_info: "",
      },
      rules: {},
    };
  },
  mounted() {
    this.getCompanyDetial()
  },
  methods: {
    submitForm(formName) {
      let params = {
        promotion_system: this.info_form.promotion_system.join(","),
        talent_incentives: this.info_form.talent_incentives.join(","),
        capability_development: this.info_form.capability_development.join(","),
        talent_development_info: this.info_form.talent_development_info,
      };
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$httpcompany.axiosPost(
            this.$api.companySaveTalentDevelopment,
            params,
            (res) => {
              if (res.code == 200) {
                this.$message.success("保存成功");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          if (res.data.promotion_system) {
            this.info_form.promotion_system =
              res.data.promotion_system.split(",");
          }
          if (res.data.talent_incentives) {
            this.info_form.talent_incentives =
              res.data.talent_incentives.split(",");
          }
          if (res.data.capability_development) {
            this.info_form.capability_development =
              res.data.capability_development.split(",");
          }
          
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.info_form {
  padding-bottom: 20px;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #393837;
    margin-bottom: 34px;
  }
}
.el-checkbox-button {
  margin-right: 12px;
  margin-bottom: 12px;
  background: #ffffff;
  ::v-deep .el-checkbox-button__inner {
    border: 1px solid #e6e8eb;
    border-radius: 4px 4px 4px 4px;
    font-weight: 500;
    font-size: 14px;
    color: #313640;
    box-shadow: none;
  }
}
.el-checkbox-button.is-checked {
  background: #dedbff;
  ::v-deep .el-checkbox-button__inner {
    border: 1px solid #685ef5;
    color: #685ef5;
    background: #dedbff;
    box-shadow: none;
    position: relative;
    &::after {
      content: "✓"; /* 显示对号 */
      position: absolute; /* 绝对定位 */
      right: 0px; /* 距离右侧 8px */
      bottom: -2px; /* 距离底部 4px */
      color: #fff; /* 对号颜色 */
      font-size: 14px; /* 对号字体大小 */
    }
    &::before {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      border-width: 10px; /* 控制三角形大小 */
      border-style: solid;
      border-color: transparent #685ef5 #685ef5 transparent; /* 颜色和方向，这里是右下角三角形 */
    }
  }
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: #dedbff !important;
}
.save_button {
  width: 86px;
  height: 34px;
  background: #685ef5;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
::v-deep .el-textarea__inner {
  height: 100px !important;
}
</style>